<template>
    <div class="short-buttons">
        <div class="short-buttons__list">
            <a
                v-if="phone !== ''"
                class="short-buttons__button custom-background-color-b"
                :href="telLink"
                aria-label="Telefonnummer"
                aria-description="Anrufen"
            >
                <neo-icon name="telefon" />
            </a>
            <template v-if="email !== ''">
                <a
                    class="short-buttons__button custom-background-color-b"
                    :href="`mailto:${email}`"
                    aria-label="E-Mail"
                    aria-description="Eine E-Mail schreiben"
                >
                    <neo-icon name="mail-alt" />
                </a>
                <template v-if="!hasChatId">
                    <a
                        v-if="webShopLink !== ''"
                        class="short-buttons__button custom-background-color-b"
                        :href="`${webShopLink}`"
                    >
                        <neo-icon name="shop" />
                    </a>
                    <a
                        v-else
                        class="short-buttons__button custom-background-color-b"
                        href="/unverbindliche-Reservierung"
                        aria-label="Unverbindliche Reservierung"
                    >
                        <neo-icon name="brief" />
                    </a>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
import neoIcon from '../icon/icon.vue';

export default {
    name: 'ShortButtons',
    components: {
        neoIcon
    },
    data() {
        return {
            phone: window.phone,
            telLink: `tel:${window.areaCode}-${window.phone}`,
            email: window.email,
            hasChatId: window.hasChatId,
            webShopLink: window.webShopLink
        };
    }
};
</script>